module.exports = __webpack_public_path__ + "img/xiaozi_yida.736b7e16.png";